// @flow

import styled from 'styled-components';
import { colors, fontWeight } from '../constants';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const FieldNotice = styled.small`
  font-family: Untitled Sans, sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.darkGrey};
  ${fontWeight('normal')}
`;

export default FieldNotice;
